module.exports = __webpack_public_path__ + "img/11825390_L.01729c73.png";